// extracted by mini-css-extract-plugin
export default {"container":"WhyUs_container__pFfng","heading":"WhyUs_heading__bRYA7","why":"WhyUs_why__wzSa-"};